<script>
    export let text;
</script>
<span 
	class="tw-col-span-2 tw-text-xs tw-uppercase tw-font-medium tw-tracking-widest tw-leading-tight tw-cursor-pointer hover:tw-text-green-400">
	{text}
</span>